import { IPolicyQuoteRequest } from '../model/IPolicyQuoteRequest'
import { IPolicyQuoteResponse } from '../model/IPolicyQuoteResponse'
import axiosInstance from '../services/apis'

export const postPolicyQuote = async (
    policyQuoteRequest: IPolicyQuoteRequest
) => {
    const response: IPolicyQuoteResponse = await axiosInstance.post(
        `/api/IMKPolicy/imk/quote`,
        policyQuoteRequest,
        { headers: { 'Content-Type': 'application/json' } }
    )
    return response
}
